import React from 'react';
import { Toolbar, Grid } from '@material-ui/core';

import { withRouter } from 'react-router-dom';

import ButtonStyledLink from '../ux/ButtonStyledLink';

import targetLogo from '../../assets/target.svg';
import userLogo from '../../assets/users_1.svg';
import { connect } from 'react-redux';


const footerStyle = {
  backgroundColor: 'white',
  fontSize: '20px',
  color: '#111936',
  // borderTop: "1px solid #E7E7E7",
  textAlign: 'center',
  position: 'fixed',
  left: '0',
  bottom: '0',
  height: '55px',
  width: '100%',
  paddingLeft: '0px',
  paddingRight: '0px',
};

function BottomHeader(props) {
  const active_style = {
    width: '25vw',
    'border-top': '2px solid',
    'border-color': '#111936',
  };
  const non_active_style = { width: '25vw' };

  return (
    <Toolbar style={footerStyle}>
      <Grid container justify="space-between" alignItems="center">
        <Grid
          container
          justifyContent="stretch"
          justify="space-evenly"
          style={{
            fontSize: 12,
          }}
        >
          <Grid
            item
            md={3}
            style={
              props.location.pathname === '/influencer/campaigns' ? active_style : non_active_style
            }
          >
            <ButtonStyledLink
              to={'/influencer/campaigns'}
              label={'My Campaigns'}
              icon={targetLogo}
            />
          </Grid>
          <Grid
            item
            md={3}
            style={
              props.location.pathname === '/influencer/settings/personal-settings'
                ? active_style
                : non_active_style
            }
          >
            <ButtonStyledLink
              to={'/influencer/settings/personal-settings/'}
              label={'My Account'}
              icon={userLogo}
            />
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  );
}

const mapStateToProps = (state) => ({
  loading: state.campaign.loading,
  user: state.auth.user,
});

export default connect(mapStateToProps, {})(withRouter(BottomHeader));
